import {encode} from '../encode'
import {onDomReady} from "../../components/dynamic/observer";

class Ecommerce {
  constructor() {
    this.initLayer();
    this.initEvents();
    this.initPage();
  }

  saveToLocalStorage(key, value) {
    try {
      window.localStorage.setItem(key, value)
    } catch (e) {
      console.log('Local storage unavailable');
    }
  }

  getFromLocalStorage(key, defaultValue) {
    try {
      const item = window.localStorage.getItem(key);
      if (item) {
        return item;
      }
    } catch (e) {
      console.log('Local storage unavailable');
    }
    return defaultValue;
  }

  initLayer() {
    window.dataLayer = window.dataLayer || [];
  }

  initEvents() {
    document.addEventListener('cartAdd', (e) => {
      const eventObject = this.elementToProductFieldObject(e.detail.element);
      if (!eventObject) {
        return;
      }

      if (e.detail.quantity) {
        eventObject.quantity = e.detail.quantity;
      }

      if (document.querySelector('[data-active]') && eventObject.id.indexOf('CarTyre') >= 0) {
        eventObject.price = encode(eventObject.price);
      }

      this.pushAdd(eventObject);
    });
  }

  initPage() {
    const productPageElement = document.querySelector('[data-ecommerce-product-page]');
    if (productPageElement) {
      const eventObject = this.elementToProductFieldObject(productPageElement);
      if (eventObject) {
        setTimeout(() => {
          this.pushDetail(eventObject);
        }, 1000);
      }
    }

    const purchasePageElement = document.querySelector('[data-ecommerce-purchase]');
    if (purchasePageElement) {
      const id = purchasePageElement.dataset.ecommercePurchaseId;
      const encodedProductObjects = purchasePageElement.dataset.ecommercePurchase;
      const productObjects = JSON.parse(encodedProductObjects);

      const purchaseKey = `ECOMMERCE_PURCHASE_${id}`;
      const alreadySaved = this.getFromLocalStorage(purchaseKey);
      if (!alreadySaved) {
        setTimeout(() => {
          this.pushPurchase(productObjects, id);
          this.saveToLocalStorage(purchaseKey, 'SAVED');
        }, 1000);

      }
    }
    // Purchase page
  }

  pushAdd(productObject) {
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currencyCode: "RUB",
        add: {
          products : [
            productObject
          ]
        }
      }
    });
  }

  pushDetail(productObject) {
    productObject.price = 0;
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currencyCode: "RUB",
        detail: {
          products : [
            productObject
          ]
        }
      }
    });
  }

  pushPurchase(productObjects, id) {
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        currencyCode: "RUB",
        purchase: {
          actionField : {
            id: id
          },
          products : [
            ...productObjects
          ]
        }
      }
    });
  }

  elementToProductFieldObject(element) {
    const ecommerceElement = element.dataset.ecommerce ? element : element.closest('[data-ecommerce]');
    if (!ecommerceElement || !ecommerceElement.dataset.ecommerce) {
      return null;
    }

    const ecommerceEncodedData = ecommerceElement.dataset.ecommerce;
    if (!ecommerceEncodedData) {
      return null;
    }

    return JSON.parse(ecommerceEncodedData);
  }
}

onDomReady(() => {
  const ecommerce = new Ecommerce();
});
